import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { NAV_LINKS, EMAIL, INSTAGRAM } from "../data/site";
import { scrollToSection, getLenis } from "../lib/lenis";

export const SiteMenu = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const lenis = getLenis();
    if (!lenis) return;
    open ? lenis.stop() : lenis.start();
  }, [open]);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToSection(id), 450);
  };

  return (
    <>
      <button
        data-testid="menu-toggle-btn"
        onClick={() => setOpen((v) => !v)}
        className="fixed top-6 right-6 md:top-8 md:right-10 z-[80] font-jetmono text-[10px] tracking-[0.3em] uppercase text-white bg-black/70 backdrop-blur-md border border-[#333] px-4 py-2.5 hover:bg-white hover:text-black hover:border-white transition-colors duration-300"
      >
        {open ? "[ CLOSE ]" : "[ MENU ]"}
      </button>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="fullscreen-menu"
            initial={{ clipPath: "inset(0 0 100% 0)" }}
            animate={{ clipPath: "inset(0 0 0% 0)" }}
            exit={{ clipPath: "inset(0 0 100% 0)" }}
            transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
            className="fixed inset-0 bg-black z-[70] flex flex-col justify-between px-6 md:px-10 pt-24 pb-8"
          >
            <div className="flex flex-col">
              {NAV_LINKS.map((link, i) => (
                <div key={link.id} className="overflow-hidden border-b border-[#222]">
                  <motion.button
                    data-testid={`nav-link-${link.id}`}
                    initial={{ y: "110%" }}
                    animate={{ y: 0 }}
                    transition={{ delay: 0.25 + i * 0.08, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    onClick={() => go(link.id)}
                    className="group flex items-baseline gap-4 md:gap-8 py-3 md:py-5 text-left w-full"
                  >
                    <span className="font-jetmono text-xs text-[#808080] group-hover:text-white transition-colors duration-300">
                      {link.index}
                    </span>
                    <span className="font-syncopate font-bold uppercase leading-none text-4xl sm:text-6xl lg:text-8xl tracking-tight text-white group-hover:translate-x-4 group-hover:text-outline transition-transform duration-500">
                      {link.label}
                    </span>
                  </motion.button>
                </div>
              ))}
            </div>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.7, duration: 0.5 }}
              className="flex flex-col md:flex-row md:items-end justify-between gap-4 font-jetmono text-[11px] tracking-[0.2em] uppercase text-[#808080]"
            >
              <a data-testid="menu-email-link" href={`mailto:${EMAIL}`} className="hover:text-white transition-colors duration-300">
                {EMAIL}
              </a>
              <a data-testid="menu-instagram-link" href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-300">
                @KHUSHPATELPHOTOGRAPHY
              </a>
              <span>LOS ANGELES, CA</span>
            </motion.div>
          </motion.nav>
        )}
      </AnimatePresence>
    </>
  );
};
